import { useEffect, useRef } from "react";

// Hook to debug why a component re-rendered
export function useWhyDidYouUpdate(name, props) {
  // Get a mutable ref object where we can store props for comparison next time this hook runs.
  const previousProps = useRef();

  useEffect(() => {
    if (previousProps.current) {
      // Get all keys from previous and current props
      const allKeys = Object.keys({ ...previousProps.current, ...props });
      // Use this object to keep track of changed props
      const changedProps = {};
      // Iterate through keys
      allKeys.forEach((key) => {
        // If previous is different from current
        if (previousProps.current[key] !== props[key]) {
          // Add to changedProps
          changedProps[key] = {
            from: previousProps.current[key],
            to: props[key],
          };
        }
      });
    }

    // Finally update previousProps with current props for next hook call
    previousProps.current = props;
  });
}

// Hook to track all state and props changes
export function useRenderTracker(componentName, props = {}) {
  const renderCount = useRef(0);
  renderCount.current += 1;

  useWhyDidYouUpdate(componentName, props);
}
